import { useEffect, useRef, useState } from "react";
import useModalActions from "@hooks/common/useModalAction";
import { WallImageSet } from "../WallReportModal/WallModalModalContent";
import MyoReportModalContent, { CoronaryAnalysis } from "./MyoReportModalContent";
import { useConfig } from "config/useConfig";
import BaseModalContent from "../BaseReportModalContent/BaseReportModalContetnt";
import { useReportModal } from "@hooks/useReportModal";

import {
  ContextKey,
  SurfaceContext,
  useBufferPool,
} from '@features/analysis/rendering/Panels/Renderers/vtkManagers';

import {
  captureSurface3D,
  cropToSquare,
} from 'utils/captureUtils';
import { usePanelContainer } from "@features/analysis/rendering/Panels/usePanelContainer";

const MyoReportModal = ({
  onClose,
}:{
  onClose: ()=>void,
}) => {

  const [imageMap, setImageMap] = useState<WallImageSet>({});
  const { config,getColors } = useConfig();


  const value: CoronaryAnalysis = {
    totalAnalysis: {
      coronaryArteryTotalVolume: config.total.volume,
      lvMuscleMass: config.total.lvMass,
      vmRatio: config.total.vmRatio,
    },
    lvMassDistribution: {
      rca: { mass: config.dist.rca.mass, percentage: config.dist.rca.pct },
      lad: { mass: config.dist.lad.mass, percentage: config.dist.lad.pct },
      lcx: { mass: config.dist.lcx.mass, percentage: config.dist.lcx.pct },
    },
    myocardialMassAtRisk: {
      coronaryVolume: config.risk.volume,
      lvMuscleMass: { mass: config.risk.lvMass.mass, percentage: config.risk.lvMass.pct },
      vmRatio: config.risk.vmRatio,
    },
  };

  const { waitingAction, closeLoadingModal } = useModalActions();
  const { analysisType } = usePanelContainer();

  const { contextPool } = useBufferPool();
  const poolRef = useRef(contextPool);
  useEffect(() => {
    poolRef.current = contextPool;
  }, [contextPool]);

  async function capture3d(
  ): Promise<string | undefined> {
    const d3context = {
      current: poolRef.current[`Surface3D` as ContextKey] as SurfaceContext,
    };
    if (!d3context) return;
    if (!d3context.current) return;

    waitingAction({ message: 'Waiting' });
    let url = await captureSurface3D(d3context.current,analysisType);
    url = await cropToSquare(url!);
    setImageMap({one: url,});
    closeLoadingModal();
  }

  useEffect(() => {
    capture3d();
  }, []);

  // const setter = async (args: any)=>{
  //   (args as [string,Promise<any>][]).forEach(async (value)=>{
  //     const img =  await value[1];
  //     setImageMap( (prev)=>({
  //       ...prev,
  //       [value[0]] :img
  //     }))
  //   })
  // }


  // useEffect(() => {
  //   waitingAction({ message: 'Waiting' });
  // }, []);

  // useEffect(()=>{
  //   if(isDone){
  //     closeLoadingModal();
  //   }else if(!Object.keys(imageMap).length){
  //     console.log('모여?')
  //    // scheduleRender('Surface3D', { type: 'captureMyocardial',setter});
  //   }
  // },[isDone])

 // if(!isDone)return;


  return (
    <BaseModalContent
      title="Myocardial Mass at Risk Analysis Report"
      // vw={68}
      // vh={80}
      onClose={onClose}
    >
      <MyoReportModalContent imageSrc={{images:imageMap}} value= {value}/>
    </BaseModalContent>
  )
}

export function useMyoReportModal(res:{updateActivatedTool: (tool: any,check: boolean) => void}){
  return useReportModal({Component:MyoReportModal,...res});
}
